<template>
  <main role="main">
    <section class="text-center">
      <div class="container mecen">
        <el-tabs tab-position="left" style="height: calc(100vh - 110px);" type="border-card">

          <el-tab-pane label="已购买课程">
            <s-Table ref="sTable" url="/GetUserAuthList" style="height:calc(100vh - 180px)">

              <!-- <el-table-column label="课程">
                <template slot-scope="scope">
                  《{{scope.row.ClassName1}}》{{scope.row.ClassName2!=''?' - 《'+scope.row.ClassName2+'》':''}}

                  <el-tag v-if="scope.row.Isxuqi==1" type="danger" effect="dark" size="mini">快到期</el-tag>
                  <el-tag v-else-if="scope.row.Isxuqi==2" type="success" effect="dark" size="mini">未到期</el-tag>
                  <el-tag v-else type="info" effect="dark" size="mini">已过期</el-tag>
                </template>
              </el-table-column> -->
              <el-table-column prop="ClassName1" label="分类1"> </el-table-column>
              <el-table-column prop="ClassName2" label="分类2"> </el-table-column>
              <el-table-column prop="startTime" label="状态" width="70">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.Isxuqi==1" type="danger" effect="dark" size="mini">快到期</el-tag>
                  <el-tag v-else-if="scope.row.Isxuqi==2" type="success" effect="dark" size="mini">未到期</el-tag>
                  <el-tag v-else type="info" effect="dark" size="mini">已过期</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="startTime" label="开始时间" width="140"> </el-table-column>
              <el-table-column prop="endTime" label="到期时间" width="140"> </el-table-column>
              <el-table-column prop="price" label="金额" width="100"> </el-table-column>
            </s-Table>
          </el-tab-pane>
          <el-tab-pane label="用户设置">
            <div class="myset">
              <div class="myset1">用户名：</div>
              {{registered["UserName"]}}
            </div>

            <div class="myset" v-for="(item,index) in list" :key="index">
              <div class="myset1"><span v-if="item.isZ">*</span>{{item.name}}：</div>

              <el-input v-if="item.key!='AgencyAddCode'" class="myset2" v-model="registered[item.key]" size="small" :type="item.type" :show-password="item.type=='password'" autocomplete="off" :maxlength="30"></el-input>
              <div class="myset4" v-else>
                <el-select class="selects" v-model="value.province" placeholder="省份" size="small">
                  <el-option v-for="item in options.province" :key="item.id" :label="item.fullname" :value="item.id">
                  </el-option>
                </el-select>
                <el-select class="selects" v-model="value.city" placeholder="城市" size="small">
                  <el-option v-for="item in options.city" :key="item.id" :label="item.fullname" :value="item.id">
                  </el-option>
                </el-select>
                <el-select class="selects" v-model="value.Area" placeholder="区/县" size="small">
                  <el-option v-for="item in options.Area" :key="item.id" :label="item.fullname" :value="item.id">
                  </el-option>
                </el-select>
              </div>

              <div class="myset3">{{item.zhu}}</div>
            </div>

            <el-button type="primary" @click="save">保存</el-button>
          </el-tab-pane>
          <!-- <el-tab-pane label="购买记录">
            <s-Table ref="sTable" url="/GetUserAuthListLog" style="height:calc(100vh - 180px)">
              <el-table-column label="课程">
                <template slot-scope="scope">
                  《{{scope.row.ClassName1}}》{{scope.row.ClassName2!=''?' - 《'+scope.row.ClassName2+'》':''}}
                </template>
              </el-table-column>
              <el-table-column prop="startTime" label="开始时间" width="140"> </el-table-column>
              <el-table-column prop="endTime" label="到期时间" width="140"> </el-table-column>
              <el-table-column prop="price" label="金额" width="100"> </el-table-column>
            </s-Table>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </section>
  </main>
</template>

<script>
import sTable from "@/components/sTable"
export default {
  components: { sTable },
  data() {
    return {
      options: { province: [], city: [], Area: [] },
      value: { province: '', city: '', Area: '' },
      list: [
        { name: '机构名称', key: 'AgencyName', zhu: '2-50位，机构名称', isZ: false, type: "text" },
        { name: '真实姓名', key: 'Name', zhu: '', isZ: false, type: "text" },
        { name: '邮箱', key: 'Email', zhu: '请填写真实有效的邮箱', isZ: false, type: "email" },
        { name: '您的机构地址', key: 'AgencyAddCode', zhu: '', isZ: true, type: "text" },
        { name: '手机号', key: 'Phone', zhu: '请填写11位有效的手机号码', isZ: true, type: "tel" },
        { name: '密码', key: 'password', zhu: '6-12位英文（区分大小写）、数字、字符的组合', isZ: true, type: "password" },
        { name: '确认密码', key: 'password2', zhu: '请再输入一遍上面的密码', isZ: true, type: "password" },
        { name: '微信', key: 'WxCode', zhu: '', isZ: false, type: "text" },
      ],
      tableData: [],
      total: 0,
      password2: '',
      registered: { AgencyName: '', AgencyAddCode: '', Name: '', Email: '', Phone: '', WxCode: '', password: '' }
    };
  },
  watch: {
    'value.province'(val, oval) {
      if (this.options.province.length == 0) return;
      this.sApi('getChildren', { id: this.value.province }).then(res => {
        this.options.city = res.result[0];
        this.options.Area = [];
        this.value.city = '';
        this.value.Area = '';
      })
    },
    'value.city'(val, oval) {
      if (this.options.city.length == 0) return;
      this.sApi('getChildren', { id: this.value.city }).then(res => {
        this.options.Area = res.result[0];
        this.value.Area = '';
      })
    }
  },
  mounted() {
    if (!this.$store.getters.getTokenValue) this.$router.push({ path: "/" });
    this.sApi('getChildren', { id: 0 }).then(res => { this.options.province = res.result[0] })
    this.sApi('memberCentre', { token: this.$store.getters.getTokenValue }).then(res => {
      var idList = res.Ifon.AgencyAddCode.split('|');
      this.value.province = idList[0];
      this.value.city = idList[1];
      this.value.Area = idList[2];

      this.sApi('getChildren', { id: 0 }).then(res => { this.options.province = res.result[0] })
      if (idList[0]) { this.sApi('getChildren', { id: idList[0] }).then(res => { this.options.city = res.result[0] }) }
      if (idList[1]) { this.sApi('getChildren', { id: idList[1] }).then(res => { this.options.Area = res.result[0] }) }
      this.registered = { ...this.registered, ...res.Ifon };
    })
  },
  created() { },
  methods: {
    getListName(list, code) {
      if (!code) return "";
      for (let i = 0; i < list.length; i++) { if (list[i].id == code) return list[i].fullname; }
    },
    save() {
      const { AgencyName, Email, Phone, password, password2 } = this.registered;
      //验证邮箱
      var reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
      if (Email != '' && !reg.test(Email)) { this.$message({ message: '请输入正确的邮箱地址', type: 'warning' }); return; }

      //验证地址
      if (this.value.province == '') { this.$message({ message: '请选择省份', type: 'warning' }); return; }
      if (this.value.city == '') { this.$message({ message: '请选择城市', type: 'warning' }); return; }
      // if (this.value.Area == '') { this.$message({ message: '请选择区/县', type: 'warning' }); return; }

      const { province, city, Area } = this.options;
      const { province: vprovince, city: vcity, Area: vArea } = this.value;

      this.registered.AgencyAdd = this.getListName(province, vprovince) + " " + this.getListName(city, vcity) + " " + this.getListName(Area, vArea);
      this.registered.AgencyAddCode = vprovince + "|" + vcity + "|" + vArea;

      //验证手机号
      if (Phone == '') { this.$message({ message: '请输入手机号', type: 'warning' }); return; }
      reg = /^1\d{10}$/;
      if (!reg.test(Phone)) { this.$message({ message: '请输入正确的手机号', type: 'warning' }); return; }

      //验证密码
      if (password != '') {
        if (password2 == '') { this.$message({ message: '请再次输入密码', type: 'warning' }); return; }
        if (password != password2) { this.$message({ message: '两次输入密码不一致', type: 'warning' }); return; }
        reg = /^(?!^\d+$|^[a-zA-Z]+$)(?:[a-zA-Z\d\W]{6,12})$/;
        if (!reg.test(password)) { this.$message({ message: '密码格式错误', type: 'warning' }); return; }
      }

      //验证机构名称
      if (AgencyName != '' && (AgencyName.length > 50 || AgencyName < 2)) {
        this.$message({ message: '机构名称不符合要求', type: 'warning' }); return;
      }

      this.registered.token = this.$store.getters.getTokenValue;
      this.sApi('setUserIfon', this.registered).then(res => {
        if (res == 2) { this.$message({ message: '此手机号已经被注册且不是当前账号', type: 'warning' }); return }
        this.$message({ message: '保存成功', type: 'success' });
      })
    }
  },
};
</script>

<style lang="scss" >
.el-tabs__content {
  height: 100%;
  overflow-y: auto;
}
.myset {
  width: 100%;
  float: left;
  margin-bottom: 15px;
  .myset1 {
    float: left;
    span {
      color: #fe2a57;
      margin-right: 5px;
    }
  }
  .myset2 {
    float: left;
    margin: 0;
  }
  .myset3 {
    float: left;
    font-size: 14px;
    color: #999;
  }
  .myset4 {
    width: 100%;
    float: left;
    .selects {
      float: left;
      width: calc(100% / 3 - 10px);
      margin-right: 10px;
      .el-input {
        margin: 0;
      }
    }
  }
}
.mecen {
  padding: 0;
  min-height: 400px;
  border-radius: 3px;
  margin-top: 15px;
}
.el-tabs__item {
  height: 60px;
  line-height: 60px;
  color: #333;
}
.el-tab-pane {
  text-align: left;
  padding: 10px 0;
}
.el-input {
  margin-bottom: 15px;
}
</style>